module.exports = __webpack_public_path__ + "img/icon_cl.8c609b35.png";